import * as api from '../api/adapters/json_api';


const type = 'api_resources/approval/requests';

export default {
  delete: (id) => api.destroy({ id, type }),
}
